import { render, staticRenderFns } from "./ProjectGroupList.vue?vue&type=template&id=af03a8f2&scoped=true&"
import script from "./ProjectGroupList.vue?vue&type=script&lang=ts&"
export * from "./ProjectGroupList.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectGroupList.vue?vue&type=style&index=0&id=af03a8f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af03a8f2",
  null
  
)

export default component.exports